<!-- Notifications toggle -->

@if (matBadge(); as badge) {
    <button mat-icon-button [matBadge]="badge" matBadgeColor="warn" matBadgePosition="before" matBadgeSize="small" (click)="clickNotification()">
        <mat-icon [svgIcon]="'feather:bell'" />
    </button>
} @else {
    <button mat-icon-button matBadgeColor="warn" matBadgePosition="before" matBadgeSize="small" (click)="clickNotification()">
        <mat-icon [svgIcon]="'feather:bell'" />
    </button>
}
